<h1 mat-dialog-title>About Visualize3D Editor</h1>
<div mat-dialog-content>
  <div><b translate>Version</b>: {{ clientVersion }}</div>
  <div><b>Copyright</b>: <a target="_blank" href="https://www.magicad.com/en/company/">MagiCAD Group</a> 2020.</div>
  <br />
  <h3 class="mat-h3">Licenses</h3>
  <pre>{{ licenses | async }}</pre>
</div>

<div mat-dialog-actions>
  <button mat-button cdkFocusInitial mat-dialog-close>Ok</button>
</div>
